"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("../utils");

var labelStyles = {
  "label": "label-label-12KH4",
  "primary": "label-primary-mmSg6",
  "success": "label-success-128QI",
  "danger": "label-danger-fAs6T"
};

var Label = function Label(_ref) {
  var children = _ref.children,
      color = _ref.color,
      className = _ref.className,
      _ref$tag = _ref.tag,
      Tag = _ref$tag === void 0 ? 'mark' : _ref$tag,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, ["children", "color", "className", "tag"]);
  return /*#__PURE__*/_react["default"].createElement(Tag, (0, _extends2["default"])({
    className: _utils.classNames.use('label', color !== 'default' && color, className).from(labelStyles)
  }, restProps), children);
};

Label.displayName = "Label";
Label.propTypes = {
  color: _propTypes["default"].oneOf(['default', 'primary', 'success', 'danger'])
};
Label.defaultProps = {
  color: 'default'
};
var _default = Label;
exports["default"] = _default;